<template>
  <SettingsLayout>
    <Modal :show="modalData.show" @close="modalData.show = false">
      <template #title>
        <div>Warnung</div>
      </template>
      <template #message>
        <!-- {{ modalData.message }} -->
        <p>
          Die Daten des Raumes sowie zugewiesene Termine werden
          unwiderruflich gelöscht.
        </p>
      </template>
      <template #actions>
        <div class="">
          <div class="flex gap-5 justify-center mt-8">
            <Button
              class="mt-auto"
              @click="
                () => {
                  modalData.show = false;
                }
              "
              >Abbrechen</Button
            >

            <Button
              type="button"
              class="mt-auto"
              @click="deleteRoom(modalData.id)"
              >Löschen</Button
            >
          </div>
        </div>
      </template>
    </Modal>

    <!-- <Head title="Stammdaten - Grundeinstellungen" /> -->
    <Head :title="`${page_name} - Grundeinstellungen`" />

    <template #breadcrumb>{{ page_name }}</template>
    <template #controls>
      <HeaderLink href="/" type="close">Schließen</HeaderLink>
    </template>
    <Heading title="Behandlungsräume" />

    <p class="max-w-2xl text-sm text-oteoText mb-9">
      Bitte legen Sie hier Ihre verfügbaren Behandlungsräume mit einer Nummer
      und einer Bezeichnung des Behandlungsraumes an, z.B. Nr. 1 Prophylaxeraum.
    </p>

    <Button
      v-if="canEdit"
      href="/einstellungen/behandlungsraeume/erstellen"
      class="mb-9"
    >
      Neuen Behandlungsraum anlegen
    </Button>

    <div class="flex flex-col">
      <div class="overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 inline-block min-w-full sm:px-6 lg:px-8">
          <div class="overflow-hidden">
            <table class="min-w-full">
              <thead class="bg-white border-b">
                <tr>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Nr.
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Benennung
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Zusatzinformation
                  </th>
                  <th
                    scope="col"
                    class="
                      text-sm
                      font-medium
                      text-gray-900
                      px-6
                      py-4
                      text-left
                      border-x-2
                    "
                  >
                    Aktion
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(room, index) in rooms"
                  :key="room.id"
                  class="border-b"
                  :class="{ 'bg-gray-100': index % 2 === 0 }"
                >
                  <TD>{{ room.number }}</TD>
                  <TD>{{ room.name }}</TD>
                  <TD>{{ room.description }}</TD>
                  <TD>
                    <div class="flex items-center text-oteo-300">
                      <Link
                        v-if="canEdit"
                        class="mr-4"
                        :href="`behandlungsraeume/${room.id}/bearbeiten/`"
                      >
                        <i class="las la-angle-right"></i>bearbeiten
                      </Link>
                      <div
                        v-if="canDelete"
                        class="cursor-pointer"
                        @click="showDeleteModal(room.id)"
                      >
                        <i class="las la-times"></i>
                        löschen
                      </div>
                    </div>
                  </TD>
                </tr>

                <tr>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                  <TD></TD>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </SettingsLayout>
</template>

<script setup>
import TD from "@/Components/Table/Element.vue";
import SettingsLayout from "@/Layouts/Settings.vue";
import Input from "@/Components/Settings/Input.vue";
import Label from "@/Components/Settings/Label.vue";
import Button from "@/Components/Button.vue";
import HeaderLink from "@/Components/Settings/HeaderLink.vue";
import Heading from "@/Components/Settings/Heading.vue";
import Modal from "@/Components/Settings/Modal.vue";
import { Link, Head, useForm } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";
import { ref } from "vue";

const page_name = "Behandlungsräume";

defineProps({
  rooms: Array,
});

const canEdit = Inertia.page.props.auth.can["edit settings"];
const canDelete = Inertia.page.props.auth.can["delete settings"];

const modalData = ref({
  show: false,
  id: Number,
});

function showDeleteModal(id) {
  modalData.value.id = id;
  modalData.value.show = true;
}

function deleteRoom(id) {
  Inertia.delete(`/rooms/${id}`, {}, { preserveState: true, replace: true });
  modalData.value.show = false;
}

const form = useForm({});
</script>
